// src/pages/projects/fitness/EditWorkoutRow.tsx
import React from "react";
import StyledButton from "../../components/button";
import StyledInput from "../../components/input";

interface EditWorkoutRowProps {
  set: any;
  mode: "lift" | "run";
  onChange: (field: string, value: string) => void;
  onDelete: () => void;
}

const EditWorkoutRow: React.FC<EditWorkoutRowProps> = ({
  set,
  mode,
  onChange,
  onDelete,
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        marginBottom: "10px",
        flexWrap: "nowrap",
        overflowX: "auto",
      }}
    >
      {mode === "lift" ? (
        <>
          <StyledInput
            type="number"
            value={set.reps}
            onChange={(e) => onChange("reps", e.target.value)}
            placeholder="Reps"
            style={{ minWidth: 70 }}
          />
          <StyledInput
            type="number"
            value={set.weight}
            onChange={(e) => onChange("weight", e.target.value)}
            placeholder="Weight"
            style={{ minWidth: 70 }}
          />
          <StyledInput
            type="number"
            value={set.rpe}
            onChange={(e) => onChange("rpe", e.target.value)}
            placeholder="RPE"
            style={{ minWidth: 70 }}
          />
        </>
      ) : (
        <>
          <StyledInput
            type="number"
            value={set.distance}
            onChange={(e) => onChange("distance", e.target.value)}
            placeholder="Distance"
            style={{ minWidth: 70 }}
          />
          <StyledInput
            type="number"
            value={set.pace}
            onChange={(e) => onChange("pace", e.target.value)}
            placeholder="Pace"
            style={{ minWidth: 70 }}
          />
          <StyledInput
            type="number"
            value={set.time}
            onChange={(e) => onChange("time", e.target.value)}
            placeholder="Time"
            style={{ minWidth: 70 }}
          />
        </>
      )}
      <StyledButton
        onClick={onDelete}
        style={{
          width: "32px",
          height: "32px",
          padding: 10,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f5f5f5",
          border: "1px solid #aaa",
          borderRadius: "4px",
          color: "#000",
          fontSize: "16px",
          marginTop: "2px",
        }}
      >
        🗑️
      </StyledButton>
    </div>
  );
};

export default EditWorkoutRow;
